<script lang="ts" setup>
import type { MessageAttachmentDTO } from '@nora-monorepo/nora-api-client';
import {
  bgFillQuaternary,
  prettyPrintFileSize,
} from '@nora-monorepo/ui-shared';

import { getIcon } from '#nora-chat-ui/utils/get-extension';

interface VideoPreviewProps {
  attachment: MessageAttachmentDTO;
  isMyMessage: boolean;
}

defineProps<VideoPreviewProps>();
</script>

<template>
  <div class="flex justify-center items-center h-full">
    <div
      class="w-32 h-28 flex justify-center float-right flex-col rounded-xl p-2"
      :class="bgFillQuaternary"
    >
      <span
        class="mi md-36 mx-auto"
        :class="[getIcon(attachment.mimeType)]"
      />
      <span class="text-xs line-clamp-3 text-center mb-1">{{
        attachment.fileName
      }}</span>
      <span class="text-xs text-center">{{
        prettyPrintFileSize(attachment.size)
      }}</span>
    </div>
  </div>
</template>
